/**
 * Trunnion AI - Audit API Endpoints
 */

import apiClient from './client';
import type {
  AuditLogResponse,
  AuditLogFilters,
  ATOExportConfig,
} from '@/types';

const BASE = '/audit';

export const auditApi = {
  list: async (filters?: AuditLogFilters): Promise<AuditLogResponse> => {
    const { data } = await apiClient.get(`${BASE}/events`, { params: filters });
    return data;
  },

  export: async (config: ATOExportConfig): Promise<Blob> => {
    const { data } = await apiClient.post(`${BASE}/export`, config, {
      responseType: 'blob',
    });
    return data;
  },

  getEventTypes: async (): Promise<string[]> => {
    const { data } = await apiClient.get(`${BASE}/event-types`);
    return data;
  },

  getStats: async (params?: {
    startDate?: string;
    endDate?: string;
  }): Promise<{
    totalEvents: number;
    byType: Record<string, number>;
    byClassification: Record<string, number>;
  }> => {
    const { data } = await apiClient.get(`${BASE}/stats`, { params });
    return data;
  },
};
